import mix from '@utils/styles/mix'

import styles from './SvgIcon.module.css'

// Bez label ikona jest dekoracyjna (ukryta przed czytnikiem); z label ma role="img".
export default function SvgIcon ({ name, size, label, className, ...rest }) {
    return (
        <svg
            aria-hidden={label ? undefined : 'true'}
            aria-label={label}
            className={mix([styles.icon, size === 'sm' && styles.sm, className])}
            focusable="false"
            role={label ? 'img' : undefined}
            {...rest}
        >
            <use href={`#i-${name}`} />
        </svg>
    )
}
